<template>
	<div :class="isPc == true ? 'about warp' : ''">
		<div v-if="isPc == true" class="Nav-left">
			<ul>
				<li class="bluefont" :style="tabar_list_cur == index ? 'background-color: #0060B1; color: #fff;' : ''"
					@click="change(index,item.css)" v-for="(item, index) in tabar_list" :key="index">
					{{ item }}
				</li>
			</ul>
		</div>
		<div v-if="isPc == false" class="mob-tabar">
			<ul class="bluefont" id="nav">
				<li :style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
					@click="tabarchange(index,item.css)" v-for="(item, index) in tabar_list" :key="index">
					{{ item }}{{item.css}}
				</li>
			</ul>
		</div>
		<!-- <div style="width: 100%;" id="nav">
			<ul style="
			width: 100%;
			height: 1.8rem;
			overflow-x: auto;
			overflow-y:hidden;
			display:-webkit-box;
			" id="nav">
				<li style="width: 300px; background-color: salmon;">11111</li>
				<li style="width: 300px; background-color: antiquewhite;">22</li>
				<li style="width: 300px; background-color: cadetblue;">333</li>
			</ul>
		</div> -->

		<!-- <div style="width: 100%;">
			<ul style="display: flex;">
				<li v-for="(item,index) in list" :key="index">{{ item }}</li>
			</ul>
		</div> -->

		<div style="width: 100%" id="nav">
			<ul style="display: flex">
				<li v-for="(item, index) in tabar_list" :key="index">
					<div>{{ item.nickname }}</div>
				</li>
			</ul>
		</div>

		<!-- <div style="width: 100%; white-space: nowrap;" id="nav">
			<ul style="display: flex;">
				<li  style="background-color: salmon;  width: 300px;" v-for="(item,index) in tabar_list" :key="index">{{ item.nickname }}</li>
			</ul>
		</div> -->
		<div v-if="css == 1">
			<div v-if="data" :class="isPc == true ? 'article' : 'article-mob warp-mob'">
				<div class="articleTitle bluefont">{{ data.title }}</div>
				<div class="articleText">
					<div v-html="data.textcontent"></div>
				</div>
			</div>
		</div>
		<div v-else>
			<div v-if="datas" class="manager_cont" :class="isPc == true ? 'article' : ''">
				<ul v-if="isPc == true" class="manager_cont_list">
					<li @click="getpage(item.id)" class="manager_cont_list_item" v-for="item in datas" :key="item.tiem">

						<div class="manager_cont_list_item_date bluefont">
							<h1>
								{{ item.createtime.substring(8, 10) }}
								<p>/{{ item.createtime.substring(5, 7) }}</p>
							</h1>
						</div>
						<div class="manager_cont_list_item_text">
							<h2>{{ item.title }}</h2>
							<p>{{ item.introduction }}</p>
						</div>
					</li>
				</ul>
				<ul v-if="isPc == false" class="manager_cont_list-mob warp-mob">
					<li @click="getpage(item.id)" class="manager_cont_list_item" v-for="item in datas" :key="item.tiem">
						<div class="manager_cont_list_item_date bluefont">
							<h1>
								{{ item.createtime.substring(8, 10) }}
								<p>/{{ item.createtime.substring(5, 7) }}</p>
							</h1>
							<h2>{{ item.title }}</h2>
							<span>></span>
						</div>
						<div class="manager_cont_list_item_text">
							<p>{{ item.introduction }}</p>
						</div>
					</li>
				</ul>
				<div v-if="isPc == true && datas.length>0" class="manager_pagination warp">
					<el-pagination @current-change="handleCurrentChange" background :current-page="currentPage"
						layout="prev, pager, next" :total="data_length" :page-size="page_size"></el-pagination>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	export default {
		name: 'WebLijinhospitalAboutHospital',

		data() {
			return {
				isPc: true,
				pid: 0,
				title: '',
				tabar_list: [],
				tabar_list_cur: 0,
				data: null,
				css: 1,
				datas: [],
				currentPage: 1,
				data_length: 0,
				page_size: 5,
			};
		},

		mounted() {
			if ('id' in this.$route.query) {
				this.pid = this.$route.query['id'];
				this.title = this.$route.query['name'];
			} else {
				console.log('error');
			}
			if (document.body.clientWidth <= 820) {
				this.isPc = false;
				console.log(this.isPc);
			} else {
				this.isPc = true;
				console.log(this.isPc);
			}
			this.getdata(0);
		},

		methods: {
			change(index, css) {
				this.tabar_list_cur = index;
				this.css = css
				this.data = null
				this.datas = null
				this.getdata(index);
			},
			tabarchange(index, css) {
				this.tabar_list_cur = index;
				this.css = css
				this.data = null
				this.datas = null
				this.getdata(index);
			},
			getdata(i) {
				let _t = this;
				this.$axios({
						url: 'http://www.ljxzxyy.cn/api/index/article',
						params: {
							pid: _t.pid
						}
					})
					.then((res) => {
						//请求成功
						console.log('article', res.data.data);
						let plist = res.data.data;

						let index_arr = [];
						let cat = [];
						for (var i1 = 0; i1 < plist.length; i1++) {
							_t.tabar_list[i1] = plist[i1]['nickname'];
							index_arr[i1] = plist[i1]['id'];
							cat[i1] = plist[i1]['css'];
						}
						let category_id = index_arr[i];
						this.css = cat[i]
						var num = 1
						if (this.css == 0) {
							num = 5
						}
						console.log(this.css)
						this.$axios({
								url: 'http://www.ljxzxyy.cn/api/index/article',
								params: {
									category_id: category_id,
									num: num,
									page: 1
								}
							})
							.then((response) => {
								//请求成功
								console.log('about', response.data);
								if (this.css == 0) {
									this.datas = response.data.data.list
								} else {
									if (response.data.data.list[0]) {
										this.$axios({
												url: 'http://www.ljxzxyy.cn/api/index/article',
												params: {
													id: response.data.data.list[0].id
												}
											})
											.then((res) => {
												//请求成功
												console.log('article', res.data);
												this.data = res.data.data;
											})
											.catch((error) => {
												//请求失败
												console.log('article', error);
											});
									}
								}

							})
							.catch((error) => {
								//请求失败
								console.log('about', error);
							});
					})
					.catch((error) => {
						//请求失败
						console.log('article', error);
					});
			},
			handleCurrentChange(pageNumber) {
				this.currentPage = pageNumber;
				this.getdatas(this.tabar_list_cur);
			},
			// 内容页
			getpage(e) {
				this.$router.push({
					path: '/content',
					query: {
						title: this.tabar_list[this.tabar_list_cur],
						id: e
					}
				});
			},
			getdatas(i) {
				let _t = this;
				if (_t.pid == 0) {
					_t.tabar_list[0] = '搜索结果';
					this.$axios({
							url: 'http://www.ljxzxyy.cn/api/index/article',
							params: {
								search: _t.key,
								num: this.page_size,
								page: this.currentPage
							}
						})
						.then((res) => {
							//请求成功
							console.log('article_list', res.data);
							this.datas = res.data.data.list;
							this.data_length = res.data.data.count;
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				} else {
					this.$axios({
							url: 'http://www.ljxzxyy.cn/api/index/article',
							params: {
								pid: _t.pid
							}
						})
						.then((res) => {
							//请求成功
							console.log('article', res.data.data);
							let plist = res.data.data;
							let index_arr = [];
							for (var i1 = 0; i1 < plist.length; i1++) {
								_t.tabar_list[i1] = plist[i1]['nickname'];
								index_arr[i1] = plist[i1]['id'];
							}
							let category_id = index_arr[i];
							this.$axios({
									url: 'http://www.ljxzxyy.cn/api/index/article',
									params: {
										category_id: category_id,
										num: this.page_size,
										page: this.currentPage
									}
								})
								.then((res) => {
									//请求成功
									console.log('article', res.data);
									this.data = res.data.data.list;
									this.data_length = res.data.data.count;
								})
								.catch((error) => {
									//请求失败
									console.log('article', error);
								});
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				}
			}
		}
	};
</script>

<style scoped>
	@import url('../static/css/style.css');

	#nav2 {
		overflow-x: auto;
		overflow-y: hidden;
	}

	.manager_cont_list {
		margin-left: 10px;
	}
</style>